import {Component, Injector, OnInit} from '@angular/core';
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {UpcomingCeuAdvanceSearchDialog} from "../dashboard/modals/upcoming-ceu-advance-search.dialog";
import {DashboardService} from "../dashboard/services/dashboard.service";
import {ParameterService} from "../../_services/parameter.service";
import {ProviderService} from "../../_services/provider.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {UserService} from "../dashboard/services/user.service";

@Component({
  selector: 'ceu-list',
  templateUrl: './ceu-list.component.html',
  styleUrls: ['./ceu-list.component.scss'],
})
export class CeuListComponent extends BasePageComponentDirective<any> implements OnInit {
  user: any;
  upcomingCeuTraining: any[] = []
  ceTypeParams: any = {};
  attendanceTypeParams: any = {};
  providers: any[] = [];
  disabledButtons: boolean[] = [];
  filterTotal = 0;

  constructor(
    injector: Injector,
    private dashboardService: DashboardService,
    private parameterService: ParameterService,
    private providerService: ProviderService,
    private userService: UserService,
  ) {
    super(injector);
  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();

    this.ceTypeParams = await this.parameterService.getParameterByName("CE_TYPE");
    this.attendanceTypeParams = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
    this.providers = await this.providerService.getAllProvider();
    if(this.pageQuery.filters == null) {
      this.pageQuery.filters = { dateRange: ['0'] }
    }
    this.query();
  }

  query(): void {
    this.pageQuery.sortBy = 'id';
    this.pageQuery.sortOrder = 'desc';

    this.pageQuery.columns = ['city', 'title', 'provider', 'ceType'];
    this.dashboardService.getUpcomingCEUs(this.pageQuery).then(r => {
      this.upcomingCeuTraining = r.content;
      this.disabledButtons = new Array(this.upcomingCeuTraining.length).fill(false);
      this.page.emit(r);

    });
  }

  searchCEU($event: any) {
    if ($event.key === 'Enter') {
      if(this.pageQuery.filters == null) {
        this.pageQuery.filters = { dateRange: ['0'] }
        this.filterTotal = 0;
      } else {
        this.filterTotal = this.countFilters(this.pageQuery.filters);
      }
      this.searchTerm = this.pageQuery.search;
      this.query();
    }
  }

  openAdvanceSearch(): void {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
    const dialog = this.dialog.open(UpcomingCeuAdvanceSearchDialog, {
      data: {
        ceTypes: this.ceTypeParams.parameterMembers,
        attendanceTypes: this.attendanceTypeParams.parameterMembers,
        providers: this.providers,
        pageQuery: this.pageQuery
      },
      width: dialogWidth,
      maxWidth: '100%'
    });
    dialog.componentInstance.result.subscribe(r => {
      if(r) {
        r.pageQuery = undefined;
        this.pageQuery.filters = r;
        this.pageQuery.page = 0;
        this.filters = r;
        this.filterTotal = this.countFilters(this.pageQuery.filters);
        this.query();
      }
    });
  }

  countFilters(filters: any): number {
    let i = 0;
    if(filters.attendanceType) i++;
    if(filters.ceType) i++;
    if(filters.provider) i++
    if(filters.dateRange[0] > 0) i++
    return i;
  }

  clearFilters() {
    this.pageQuery.filters = { dateRange: ['0'] }
    this.searchTerm = this.pageQuery.search;
    this.filterTotal = this.countFilters(this.pageQuery.filters);
    this.query();
  }

  enroll(d: any, index: number) {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
    const dialog = this.dialog.open(ConfirmationDialog, {
      width: dialogWidth,
      maxWidth: '100%',
      data: {
        message: `Are you sure want to enroll certification ${d.title}  by ${d.provider}?`,
        subMessage: 'We will send you an email later for further enrollment process',
        buttonCancelLabel: 'Cancel',
        buttonOkLabel: 'Yes, Enroll Me'
      }
    });

    dialog.componentInstance.result.subscribe(r => {
      if(r) {
        this.userService.enrollMe(d.id).then(r => {
          this.showAlert('Enrollment Request', 'Your enrollment request has been inquired successfully', '');
          this.disabledButtons[index] = true;
        })
      }
    })

  }
}
